import PropTypes from 'prop-types';
import {
  Grid,
  Box,
  Typography,
  Divider,
  Table,
  TableBody,
  TableRow,
} from '@mui/material';
import { lightGreen } from '@mui/material/colors';

import BookMaterialComponent from 'components/BookMaterialComponent';
import PriceComponent from 'components/PriceComponent';
import RemainingBalanceInfoComponent from 'components/SummaryComponent/RemainingBalanceInfoComponent';
import SchoolBookMaterialComponent from 'components/SchoolBookMaterialComponent';
import StyledTableCell from 'components/SummaryComponent/StyledTableCell';
import SummaryInfoComponent from 'components/SummaryComponent/SummaryTotalValueComponent/SummaryInfoComponent';
import AccommodationFee from 'components/SummaryComponent/SummaryContentComponent/CardAccommodationComponent/AccommodationFee';

function SummaryTotalValue({
  currency,
  deposit,
  header,
  isCheckout,
  showAccommodationFee,
  summaryItems,
  totalDiscount,
  totalDiscountExchanged,
}) {
  const numberFormatOptionsCustom = {
    currency,
    style: 'currency',
  };
  const remainingValue = totalDiscountExchanged - deposit;
  const hasNotInsurance =
    summaryItems?.insurances?.length <= 0 || !summaryItems?.insurances;

  return (
    <>
      <Box my={1}>
        <Divider />
      </Box>

      <Table>
        <TableBody>
          {summaryItems?.registrationFeeExchanded > 0 &&
          !Number.isNaN(summaryItems?.registrationFeeExchanded) ? (
            <TableRow key="matricula">
              <StyledTableCell component="th" scope="row">
                Matrícula
              </StyledTableCell>

              <StyledTableCell align="right">
                {summaryItems?.registrationFeeExchanded >
                  summaryItems?.registrationFeeWithDiscountExchanged && (
                  <Typography
                    variant="caption"
                    component="span"
                    sx={{
                      color: '#8a8a8a',
                      marginRight: '8px',
                      textAlign: 'right',
                      textDecoration: 'line-through',
                    }}
                  >
                    <PriceComponent
                      value={summaryItems?.registrationFeeExchanded}
                    />
                  </Typography>
                )}

                <Typography
                  component="span"
                  sx={{ textAlign: 'right', fontWeight: 900 }}
                  variant="caption"
                >
                  {summaryItems?.registrationFeeWithDiscountExchanged > 0 ? (
                    <PriceComponent
                      value={summaryItems?.registrationFeeWithDiscountExchanged}
                    />
                  ) : (
                    <strong>GRÁTIS</strong>
                  )}
                </Typography>
              </StyledTableCell>
            </TableRow>
          ) : null}

          {showAccommodationFee && (
            <TableRow key="accommodationFee">
              <StyledTableCell component="th" scope="row">
                Taxa de acomodação
              </StyledTableCell>

              <StyledTableCell align="right">
                <AccommodationFee registrationFee={summaryItems} />
              </StyledTableCell>
            </TableRow>
          )}

          {/* Todo: Correção temporária, tarefa para refatorar o BookMaterial https://app.clickup.com/t/22bmeyh */}
          {isCheckout &&
          summaryItems?.courses?.length > 0 &&
          summaryItems?.courses[0]?.bookMaterial?.id > 0 ? (
            <BookMaterialComponent
              bookMaterialPriceExchanged={
                summaryItems?.courses[0]?.bookMaterialPriceExchanged
              }
              bookMaterialNote={summaryItems?.courses[0]?.bookMaterialNote}
              bookMaterialChargedBefore={
                summaryItems?.courses[0]?.bookChargedBefore
              }
            />
          ) : (
            <SchoolBookMaterialComponent summaryItems={summaryItems} />
          )}

          {summaryItems?.accommodationSupplementExchanged > 0 &&
          !Number.isNaN(summaryItems?.accommodationSupplementExchanged) ? (
            <SummaryInfoComponent
              key="accommodationSupplementExchanged"
              title="Suplemento da acomodação"
              value={summaryItems?.accommodationSupplementExchanged}
            />
          ) : null}

          {summaryItems?.accommodations &&
          summaryItems?.accommodations[0]?.supplementPriceExchanged > 0 &&
          !Number.isNaN(
            summaryItems?.accommodations[0]?.supplementPriceExchanged
          ) ? (
            <SummaryInfoComponent
              key="accommodationSupplementExchanged"
              title="Suplemento da acomodação"
              value={summaryItems?.accommodations[0]?.supplementPriceExchanged}
            />
          ) : null}

          {summaryItems?.courseSupplementExchanged > 0 &&
          !Number.isNaN(summaryItems?.courseSupplementExchanged) ? (
            <SummaryInfoComponent
              key="courseSupplementExchanged"
              title="Suplemento do curso"
              value={summaryItems?.courseSupplementExchanged}
            />
          ) : null}

          {summaryItems?.courses &&
          summaryItems?.courses[0]?.supplementPriceExchanged > 0 &&
          !Number.isNaN(summaryItems?.courses[0]?.supplementPriceExchanged) ? (
            <SummaryInfoComponent
              key="courseSupplementExchanged"
              title="Suplemento do curso"
              value={summaryItems?.courses[0]?.supplementPriceExchanged}
            />
          ) : null}

          <TableRow key="Taxa de agenciamento">
            <StyledTableCell component="th" scope="row">
              <Box>Taxa de Agenciamento</Box>
            </StyledTableCell>

            <StyledTableCell align="right">
              <strong>GRÁTIS</strong>
            </StyledTableCell>
          </TableRow>

          <TableRow key="Suporte e Assessoria">
            <StyledTableCell component="th" scope="row">
              Suporte e Assessoria
            </StyledTableCell>

            <StyledTableCell align="right">
              <strong>GRÁTIS</strong>
            </StyledTableCell>
          </TableRow>

          {summaryItems?.discount > 0 &&
          hasNotInsurance &&
          !Number.isNaN(summaryItems?.discount) ? (
            <TableRow key="Valor Total">
              <StyledTableCell component="th" scope="row">
                Valor total
              </StyledTableCell>
              <StyledTableCell align="right">
                <Typography
                  variant="body2"
                  component="div"
                  sx={{
                    color: '#8a8a8a',
                    textDecoration: 'line-through',
                    textAlign: 'right',
                  }}
                >
                  {summaryItems?.discount > 0 &&
                  summaryItems?.totalDiscount > 0 &&
                  !Number.isNaN(summaryItems?.totalDiscount) &&
                  !Number.isNaN(summaryItems?.discount) ? (
                    <PriceComponent
                      value={
                        isCheckout
                          ? summaryItems?.totalDiscount
                          : summaryItems?.totalExchanged
                      }
                    />
                  ) : null}
                </Typography>
              </StyledTableCell>
            </TableRow>
          ) : null}

          {summaryItems?.discount > 0 &&
          hasNotInsurance &&
          !Number.isNaN(summaryItems?.discount) ? (
            <TableRow key="DESCONTO Fluencypass">
              <StyledTableCell component="th" scope="row">
                <Typography
                  component="div"
                  sx={{ fontWeight: 'bold' }}
                  variant="body2"
                >
                  DESCONTO Fluencypass
                </Typography>
              </StyledTableCell>

              <StyledTableCell sx={{ color: lightGreen[800] }} align="right">
                <Typography
                  component="div"
                  sx={{ fontWeight: 'bold', textAlign: 'right' }}
                  variant="body2"
                >
                  {summaryItems?.discount > 0 &&
                  !Number.isNaN(summaryItems?.discount) ? (
                    <>
                      <Box component="span">-</Box>
                      <PriceComponent value={summaryItems?.discount} />
                    </>
                  ) : (
                    <PriceComponent value={0} />
                  )}
                </Typography>
              </StyledTableCell>
            </TableRow>
          ) : null}
        </TableBody>
      </Table>

      <Box textAlign="left" mt={2} mx={2}>
        <Grid container alignItems="center" spacing={2}>
          <Grid item xs={6}>
            <Typography
              component="div"
              sx={{ fontWeight: 'bold', textTransform: 'uppercase' }}
              variant="body2"
            >
              Valor total
              {summaryItems?.discount > 0 &&
                hasNotInsurance &&
                !Number.isNaN(summaryItems?.discount) && (
                  <Box component="span">&nbsp;com desconto</Box>
                )}
            </Typography>
          </Grid>

          <Grid item xs={6}>
            <Typography
              component="div"
              sx={{
                fontWeight: 'bold',
                textAlign: 'right',
                textTransform: 'uppercase',
              }}
              variant="h5"
            >
              {totalDiscountExchanged &&
              !Number.isNaN(totalDiscountExchanged) ? (
                <PriceComponent value={totalDiscountExchanged} />
              ) : (
                <Box>-</Box>
              )}
            </Typography>

            {remainingValue > 0 && !Number.isNaN(remainingValue) && (
              <Typography
                component="div"
                sx={{ textAlign: 'right' }}
                variant="caption"
              >
                {totalDiscount && !Number.isNaN(totalDiscount) ? (
                  <Box>
                    (
                    <PriceComponent
                      value={totalDiscount}
                      numberFormat={numberFormatOptionsCustom}
                    />
                    )
                  </Box>
                ) : null}
              </Typography>
            )}
          </Grid>
        </Grid>
      </Box>

      {remainingValue > 0 && !Number.isNaN(remainingValue) && (
        <>
          <Box my={2}>
            <Divider />
          </Box>

          <Box textAlign="left" mt={2} mx={2}>
            <Grid container alignItems="center" spacing={2}>
              <Grid item xs={12}>
                <Box mb={2}>
                  <Typography
                    component="div"
                    sx={{
                      fontWeight: 'bold',
                      textAlign: 'center',
                      textTransform: 'uppercase',
                    }}
                    variant="body2"
                  >
                    {header}
                  </Typography>

                  <Typography variant="h4" component="div">
                    <Box textAlign="center" fontWeight="bold">
                      {deposit && !Number.isNaN(deposit) ? (
                        <PriceComponent value={deposit} />
                      ) : (
                        <Box>-</Box>
                      )}
                    </Box>
                  </Typography>

                  <Typography variant="body2" component="div">
                    {deposit && !Number.isNaN(deposit) ? (
                      <Box textAlign="center">
                        (
                        <PriceComponent
                          value={deposit / summaryItems.exchangeRate}
                          numberFormat={numberFormatOptionsCustom}
                        />
                        )
                      </Box>
                    ) : null}
                  </Typography>
                </Box>
              </Grid>
            </Grid>

            <Box mb={2}>
              <RemainingBalanceInfoComponent
                value={
                  <PriceComponent
                    numberFormat={numberFormatOptionsCustom}
                    value={remainingValue / summaryItems.exchangeRate}
                  />
                }
              />
            </Box>
          </Box>
        </>
      )}
    </>
  );
}

SummaryTotalValue.propTypes = {
  currency: PropTypes.string,
  deposit: PropTypes.number,
  header: PropTypes.string,
  isCheckout: PropTypes.bool,
  summaryItems: PropTypes.instanceOf(Object).isRequired,
  totalDiscount: PropTypes.number,
  totalDiscountExchanged: PropTypes.number,
};

SummaryTotalValue.defaultProps = {
  currency: '$',
  deposit: 0,
  header: 'Reserve agora por apenas',
  isCheckout: false,
  totalDiscount: 0,
  totalDiscountExchanged: 0,
};

export default SummaryTotalValue;
